/** student/progress — KEYS. */
export const studentProgressKeys = {
  all: () => ['student', 'progress'] as const,
};
